export default __webpack_public_path__ + "static/media/logo_white_post_horiz.825f6612.png";